<div class="NgxEditor__MenuItem--IconContainer" [innerHTML]="html | sanitizeHtml" (mousedown)="toggle($event)"
  [title]="getTitle(name)">
</div>
